import { storyblokEditable } from "@storyblok/react";
import Marquee from "react-fast-marquee";

const CharityLogos = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="font-display charities">
      <p className="charity-intro">
        We're proud these nonprofits call Catalyst home
      </p>
      <Marquee gradient={false} className="custom-marquee">
        <img
          src="https://a.storyblok.com/f/341980/69x68/2037d966d0/comicrelief18.png"
          alt="Comic Relief logo"
        />

        <img
          src="https://a.storyblok.com/f/341980/180x70/32712db3c4/starlight_children-s_foundation_logo.png"
          alt="Comic Relief logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/73x88/32b39cefa3/logo_aism_ita.png"
          alt="AISM ITA logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/116x82/1aab9603e8/st-jude-children-s-research-hospital.png"
          alt="St Jude Childrens Reserach Hospital logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/242x66/26c24eeb1c/samaritans.png"
          alt="Samaritans logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/278x54/42f61a3753/hsus-final.png"
          alt="Human Society logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/86x74/02b94c895f/un.png"
          alt="United Nations logo"
        />

        <img
          src="https://a.storyblok.com/f/341980/177x60/ff411bb575/no-kid-hungry.png"
          alt="No Kid Hungry logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/131x76/305693d3df/irish-cancer-society-logo-vector.png"
          alt="Irish Cancer Society logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/77x76/0007f2f7a4/four-paws.png"
          alt="Four Paws logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/195x44/5f28b8cf69/make-a-wish.png"
          alt="Make A Wish logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/158x70/d50cc92f3c/mind.png"
          alt="Mind logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/193x40/f20d2c6408/save-the-children_logo.png"
          alt="Save The Chilkdren logo"
        />
        <img
          src="https://a.storyblok.com/f/341980/180x70/32712db3c4/starlight_children-s_foundation_logo.png"
          alt="Starlight Childrens Foundation logo"
        />
      </Marquee>
      {/* <img src={blok.homecharitylogo.filename} alt="charity logos" /> */}
    </div>
  );
};

export default CharityLogos;
